import styled from 'styled-components';
import styledProps from 'styled-props';
import ds from 'designsystem';

const Header1 = styled.h1`
    color: ${styledProps({
    primary: ds.brand('product'),
    secondary: ds.brand('text'),
  })};
    font-size: ${ds.fs('xxl')};
    font-family: ${ds.get('type.fontFamily.headline')};
    font-weight: ${ds.get('type.fontWeight.bold')};
    line-height: ${ds.get('type.lineHeight.xxl')};
`;

export default Header1;



// WEBPACK FOOTER //
// ./src/elements/Header1.js